import React from "react";
import { Card, Dropdown, Row } from "react-bootstrap";
import { loadingRow } from "../../../helpers/loading";

export const SingleCardMetric = ({
  title = "",
  // Short enough to sit on one line in a narrow card - the full wording belongs in tooltip.
  subtitle = "",
  tooltip = "",
  total = null,
  onHandleClick = null,
  cursor = false,
  active = false,
  isLoading = false,
  types = [],
  selectedType,
  onSelectType,
}: any) => {
  const onUpdate = (e: any) => {
    const newType = types.find((t: any) => t.key === e);
    if (onSelectType) {
      onSelectType(newType?.name);
    }
  };

  return (
    <Card
      className={
        active
          ? "bg-light cursor-pointer button button-today-filter w-100 h-100"
          : cursor
            ? "app-light-color cursor-pointer button w-100 h-100"
            : "bg-light w-100 h-100"
      }
      onClick={onHandleClick}
    >
      <Card.Body className="d-flex flex-column justify-content-between">
        <Row className="text-center">
          {types.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle variant="link" className="metric-dropdown-toggle text-decoration-none w-100 text-wrap p-0 mb-0">
                {selectedType}
              </Dropdown.Toggle>
              <Dropdown.Menu className="z-2">
                {types.map((i: any) => (
                  <Dropdown.Item key={i.key} onClick={() => onUpdate(i.key)}>
                    {i.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            // mb-0 only when a subtitle follows it, so the dozen cards that pass no subtitle
            // keep the spacing they had before subtitles existed
            <h5 className={subtitle ? "app-orange-text p-0 mb-0" : "app-orange-text p-0"} title={tooltip || undefined}>
              {title}
            </h5>
          )}
          {subtitle && (
            <small className="text-muted p-0 lh-sm" title={tooltip || undefined}>
              {subtitle}
            </small>
          )}
        </Row>
        {isLoading ? (
          loadingRow()
        ) : (
          <Row className="text-center">
            <h1 className="text-muted">{selectedType ? types.find((t: any) => t.name === selectedType)?.count : total}</h1>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};
